<app-mobilephone-search-header
  class="mobilephone-search-header"
  detailsPageText="Spesifikasjoner"
  searchPageText="Velg telefon"
  [isManualRegistration]="data.isManualRegistration"
  [selectedMobilePhoneVariant]="selectedMobilePhoneVariant"
  (backToMobileSearch)="onBackToSearch()"
/>
<div #dialogContent mat-dialog-content>
  @if (!selectedMobilePhoneVariant && !data.isManualRegistration) {
    <div class="hardware-search">
      <div class="search-filter-wrapper">
        <app-mobilephone-search-filter
          [categories]="categories"
          [isEquipmentUpgradeEnabled]="isEquipmentUpgradeEnabled()"
          [isLoadingFilters]="isLoadingFilters"
          [isLoadingSearchResults]="isLoadingSearchResults"
          [isManualRegistrationSupported]="true"
          [manufacturers]="manufacturers"
          [searchText]="searchText"
          [selectedAvailableForList]="selectedAvailableForList"
          [selectedCategories]="selectedCategories"
          [selectedManufacturers]="selectedManufacturers"
          (filterChange)="onFilterChange($event)"
          (registerManually)="data.isManualRegistration = true"
        />
      </div>
      <div class="search-result-wrapper">
        <app-hardware-search-result
          [defaultImage]="(selectedTheme$ | async).phone_illustration"
          [displayType]="displayType"
          [isLoadingSearchResults]="isLoadingSearchResults"
          [isManualRegistrationSupported]="data.mobileProductInCart ? false : true"
          [loadingVariantsGroupSlug]="loadingGroupVariantsForGroup"
          [searchResultPhoneGroups]="mobilePhoneVariantGroupsToDisplay"
          (changeDisplayType)="displayType = $event"
          (itemClicked)="onGroupSelected($event)"
          (registerManually)="data.isManualRegistration = true"
        />
      </div>
    </div>
  } @else {
    <app-mobilephone-details
      [allVoiceProducts]="allVoiceProducts()"
      [canSellCellPhoneWithSubscription]="canSellCellPhoneWithSubscription()"
      [canSellCellPhoneWithoutSubscription]="canSellCellPhoneWithoutSubscription()"
      [canSellHardwareWithLogistics]="canSellHardwareWithLogistics()"
      [groupVariants]="selectedGroupVariants"
      [isManualRegistration]="data.isManualRegistration"
      [mobilePhoneVariant]="selectedMobilePhoneVariant"
      [mobileProductInCart]="data.mobileProductInCart"
      [mobileProducts]="mobilephoneProducts()"
      (addMobilePhoneProduct)="onAddMobileProduct($event)"
      (backToSearch)="onBackToSearch()"
    />
  }
</div>
